const PACKAGE_VERSION = import.meta.env.PACKAGE_VERSION;

export const ENV_CONFIG = { PACKAGE_VERSION };
